import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import * as object_sett from '../courses/courses-data/object_settings.json';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AppService } from 'src/app/services/app/app.service';
import { CourseService } from 'src/app/services/course/course.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/services/global/global.service';
import { CommonService } from 'src/app/services/common/common.service';
@Component({
  selector: 'app-add-object',
  templateUrl: './add-object.component.html',
  styleUrls: ['./add-object.component.scss']
})
export class AddObjectComponent {
  public objectType!: string;
  public contentDetails: any[] = (object_sett as any).default;
  files: File[] = [];
  public selectedItem!: any
  public addObjectForm!: FormGroup;
  public content: any;
  sharedData: any;
  safeUrl: any;
  safeSrc!: SafeResourceUrl;
  public isInvalidYoutubeURL: boolean = false;
  public serverFileName: string = '';
  public imageUrl = GlobalService.imageURL;
  public isSpinnerLoading: boolean = false;
  public isUnderstandBtn: boolean = false;
  public isFileSizeError: boolean = false;
  public selectedTheme: any;
  private selectedSettingsArr: any[] = []
  constructor(public dialogRef: MatDialogRef<AddObjectComponent>, @Inject(MAT_DIALOG_DATA) public dialogData: any, private appService: AppService,
    private fb: FormBuilder, private courseService: CourseService, private sanitizer: DomSanitizer, private spinner: NgxSpinnerService, private commonService: CommonService
  ) { }
  ngOnInit(): void {
    this.objectType = this.dialogData.type;
    this.objectType = this.objectType.charAt(0).toUpperCase() + this.objectType.slice(1);
    this.selectedItem = this.dialogData.selectedObject[0];
    this.addObjectForm = this.fb.group({
      'sub_tit': ["", Validators.required],
      'subs_cont': ["", Validators.required]
    })
    this.addObjectForm.get('sub_tit')?.setValue(this.selectedItem["sub_tit"])
    this.addObjectForm.get('subs_cont')?.setValue(this.selectedItem["subs_cont"])
    if (this.selectedItem["subs_cont"]) {
      if (this.selectedItem["type"] == "youtube") {
        this.onLinkChange()
      }
      if (this.selectedItem["type"] == "video" || this.selectedItem["type"] == "audio" || this.selectedItem["type"] == "pdf"
        || this.selectedItem["type"] == "file" || this.selectedItem["type"] == "image") {
        let fileName = this.imageUrl + this.selectedItem["subs_cont"];
        // this.files.push(this.selectedItem["subs_cont"][0])
        this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(fileName);
        this.serverFileName = this.selectedItem["subs_cont"]
      }
      this.selectedItem.sett = this.contentDetails.find(item => item.type == this.selectedItem.type)["sett"]
      this.selectedSettingsArr = this.selectedItem.o_stt
      this.updateKeyValues()
    }
    if (this.selectedItem?.sett?.find(i => i.key_name === "confirm_btn")?.key_value === true) {
      this.isUnderstandBtn = true;
    }
    if (this.appService.getSessionData('theme')) {
      this.selectedTheme = this.appService.getSessionData('theme');
    }
  }
  get getControls() {
    return this.addObjectForm.controls;
  }
  isControlHasError(controlName: string, validationType: string,): boolean {
    return this.appService.isControlHasError(this.addObjectForm, controlName, validationType)
  }
  onLinkChange() {
    if (this.selectedItem.output_t == 'youtube' || (this.selectedItem["type"] == "youtube")) {
      this.extractVideoId(this.addObjectForm.get('subs_cont')?.value);
    }
  }
  isValidUrl(string) {
    try {
      new URL(string);
      return true;
    } catch (err) {
      return false;
    }
  }
  extractVideoId(url: string) {
    let videoId = '';
    this.isInvalidYoutubeURL = false;
    if (url.includes("youtube.com/watch")) {
      const start = url.indexOf("v=") + 2;
      let end: any = url.indexOf("&", start);
      if (end === -1) {
        end = undefined;
      }
      videoId = url.substring(start, end);
      return this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId)
    } else if (url.includes("youtube.com/shorts/")) {
      const urlParts = url.split("/");
      videoId = urlParts[urlParts.length - 1];
      return this.safeSrc = this.sanitizer.bypassSecurityTrustResourceUrl("https://www.youtube.com/embed/" + videoId)
    } else {
      this.isInvalidYoutubeURL = true;
      return ""
    }
  }

  onSelect(event: any) {
    this.isFileSizeError = false;
    if (this.files.length == 0) {
      this.files.push(...event.addedFiles);
    }
    else {
      this.files = [];
      this.files.push(...event.addedFiles);
    }
    const fileSizeInKB: number = this.files[0]["size"] / (1024 * 1024);

    if (fileSizeInKB > 200) {
      // File size exceeds the limit
      // Perform necessary actions (e.g., show an error message, clear the file input)
      this.files = [];
      this.isFileSizeError = true;
      return;
    }
    else {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(this.files[0]));
      this.uploadFile()
    }

  }
  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
    this.addObjectForm.get('subs_cont')?.setValue(this.files)
  }
  // set value true for selected sett
  onCheckBoxValue(item: any, event: any) {
    item["key_value"] = event.checked
    // conso
    if (item["key_name"] == 'confirm_btn') {
      if (event.checked == true) { this.isUnderstandBtn = true }
      else { this.isUnderstandBtn = false }
    }
    if (event.checked) {
      this.selectedSettingsArr.push(item.key_name);
    } else {
      const index = this.selectedSettingsArr.indexOf(item.key_name);
      if (index !== -1) {
        this.selectedSettingsArr.splice(index, 1);
      }
    }
  }
  updateKeyValues(): void {
    this.selectedItem.sett.forEach(item => {
      item.key_value = this.selectedSettingsArr.includes(item.key_name) ? true : false;
    });
  }
  onSaveCourse() {
    if (this.addObjectForm.invalid) {
      this.addObjectForm.markAllAsTouched()
    }
    else {
      if ((this.selectedItem.type == 'youtube') && this.isInvalidYoutubeURL) { return }
      if (this.dialogData.edit != true) {
        let newCourseObject: any = {}
        newCourseObject = Object.assign(this.addObjectForm.value, {});
        // newCourseObject["sett"] = this.selectedItem.sett;
        newCourseObject["o_stt"] = this.selectedSettingsArr;
        newCourseObject["type"] = this.dialogData.type;
        if (this.serverFileName) {
          newCourseObject["subs_cont"] = this.serverFileName;
        }
        this.courseService.updateSharedData(newCourseObject);
        this.dialogRef.close()
      }
      else {
        // when course edit is true;
        let newCourseObject: any = {}
        newCourseObject = Object.assign(this.addObjectForm.value, {});
        // newCourseObject["sett"] = this.selectedItem.sett;
        newCourseObject["o_stt"] = this.selectedSettingsArr;
        newCourseObject["type"] = this.dialogData.type;
        newCourseObject["s_si"] = this.selectedItem.s_si;
        if (this.serverFileName) {
          newCourseObject["subs_cont"] = this.serverFileName;
        }
        newCourseObject[""]
        this.dialogRef.close({ data_item: newCourseObject })
      }
    }
  }
  onDeleteFile() {
    this.spinner.show()
    let formData = new FormData();
    formData.append('ex_file', this.serverFileName)
    // formData.append('is_Delete','')
    formData.append('type', this.dialogData.type)
    formData.append('obj_file', '')
    this.courseService.uploadFile(formData).subscribe({
      next: (success: any) => {
        this.spinner.hide()
        if (success["status"] == 200) {
          this.serverFileName = "";
          this.files = []
          this.safeUrl = ''
          this.addObjectForm.get('subs_cont')?.setValue(this.files);
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    })
  }
  uploadFile() {
    // this.spinner.show()
    this.isSpinnerLoading = true;
    let formData = new FormData();
    formData.append('ex_file', '')
    // formData.append('is_Delete','')
    formData.append('type', this.dialogData.type)
    formData.append('obj_file', this.files[0])
    this.courseService.uploadFile(formData).subscribe({
      next: (success: any) => {
        this.addObjectForm.get('subs_cont')?.setValue(this.files);
        // this.spinner.hide()
        this.isSpinnerLoading = false;
        this.serverFileName = success.msg;
      },
      error: (error: any) => {
        this.commonService.handleError(error)
      }
    }
    )
  }
  getAcceptType() {
    if (this.selectedItem.accept_type) {
      return this.selectedItem.accept_type
    }
    else {
      let new_item: any = this.contentDetails.find(item => item.type == this.selectedItem.type)
      return new_item["accept_type"]
    }

  }
  onCancel() {
    this.dialogRef.close()
  }
  openLink() {
    window.open(this.addObjectForm.get('subs_cont')?.value, "_blank")
  }
  getFileName(serverFileName){
   return this.appService.getFileNameFromUrl(serverFileName)
  }
}
